import { createRoot } from "react-dom/client";

import "@equipmentshare/ds2/dist/assets/ds2.css";

import "./index.css";
import { App } from "./app";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);
